<template>
    <section class="body-sign">
      <div class="center-sign">
        <a href="#" class="logo pull-left">
          <img src="/img/logo-zone-a.svg" height="35" alt="OZIWEB - Zone-A" />
        </a>

        <div class="panel panel-sign">
          <div class="panel-title-sign text-right">
            <h2 class="title text-uppercase text-weight-bold m-none"><em class="fa fa-user mr-xs"></em> Connexion</h2>
          </div>
          <div class="panel-body">
            <form @submit.prevent="login">
              <div class="form-group mb-lg">
                <label for="username" class="control-label">Nom d'utilisateur</label>
                <div class="input-group input-group-icon">
                  <input v-model="username"  type="text" class="form-control input-lg" autofocus required/>
                  <span class="input-group-addon">
                    <span class="icon icon-lg">
                      <em class="fa fa-user"></em>
                    </span>
                  </span>
                </div>
              </div>

              <div class="form-group mb-lg">
                <div class="clearfix">
                  <label ref="username" for="pwd" class="pull-left control-label">Mot de passe</label>
                </div>
                <div class="input-group input-group-icon">
                  <input v-model="password"  type="password" class="form-control input-lg" required/>
                </div>
                <label class="error" v-if="error"><br>{{ error }}</label>
              </div>

              <div class="row">

                <div class="col-sm-5 text-left">
                  <button type="submit" class="btn btn-primary hidden-xs">Se connecter</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Login',
  data: function() {return {
    username: "",
    password: "",
    respData: {},
    error: null
  }},
  methods: {
   login: function () {
     const { username, password } = this;
     // console.log("Login...")

     axios({url: this.$root.$data.server_base + '/api/auth.php',
        data: {username: username, password: password}, method: 'POST' })
     .then(resp => {
        if(resp.data.error) {
          localStorage.removeItem('jwt');
          this.error = 'Compte non reconnu ou mot de passe erroné. Veuillez réessayer.';
        } else {
          // Add to all subsequent queries
          const token = resp.data.token;
          axios.defaults.headers.common['X-Custom-Authorization'] = token;
          localStorage.jwt = token;

          this.$root.$data.firstName=resp.data.firstName;
          localStorage.firstName = resp.data.firstName;

          this.$root.$data.lastName=resp.data.lastName;
          localStorage.lastName = resp.data.lastName;

          this.$root.$data.privilege=resp.data.privilege;
          localStorage.privilege = resp.data.privilege_name;

          this.$root.$data.privIsAdmin=resp.data.privIsAdmin;
          localStorage.privIsAdmin = resp.data.privIsAdmin;

          this.$root.$data.privIsSuperAdmin=resp.data.privIsSuperAdmin;
          localStorage.privIsSuperAdmin = resp.data.privIsSuperAdmin;

          this.$router.push({name:'tableaudebord'}); 

        }
     }).catch(() => {
       localStorage.removeItem('jwt');
       this.error=true;
     })
   }
  },
  mounted () {
    window.scrollTo(0, 0);
  }

}
</script>
